import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import clsx from 'clsx';
import { Tile, TileContent, TileHeader, TileTitle } from '../ui';

type CollapsibleTileProps = {
  title: string;
  defaultOpen?: boolean;
  headerActions?: ReactNode;
  contentClassName?: string;
  children: ReactNode;
};

export default function CollapsibleTile({
  title,
  defaultOpen = true,
  headerActions,
  contentClassName,
  children
}: CollapsibleTileProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Tile>
      <TileHeader
        className={clsx(
          'flex items-center justify-between gap-2',
          open ? 'border-b border-gray-100 dark:border-gray-800' : 'border-b-0'
        )}
      >
        <button
          type="button"
          className="flex min-w-0 flex-1 items-center gap-2 rounded-md text-left hover:bg-gray-50 dark:hover:bg-gray-800/50"
          onClick={() => setOpen((prev) => !prev)}
          aria-expanded={open}
        >
          {open ? (
            <ChevronDown className="h-4 w-4 shrink-0 text-gray-500 dark:text-gray-400" aria-hidden />
          ) : (
            <ChevronRight className="h-4 w-4 shrink-0 text-gray-500 dark:text-gray-400" aria-hidden />
          )}
          <TileTitle className="mb-0">{title}</TileTitle>
        </button>
        {headerActions ? (
          <div className="flex shrink-0 items-center gap-2" onClick={(event) => event.stopPropagation()}>
            {headerActions}
          </div>
        ) : null}
      </TileHeader>
      {open ? <TileContent className={contentClassName}>{children}</TileContent> : null}
    </Tile>
  );
}
